import { useHistory } from "react-router-dom";

const Hook =  () => {
  const history = useHistory();

  const navigate = (url, state) => {
    history.push(url, state)
  }

  // Pop back to the previous entry instead of pushing a new one, so the
  // history stack doesn't accumulate duplicate pages (which makes the
  // back button bounce between a page and its sub-page). Falls back to a
  // safe url when there's no in-app history to pop (e.g. deep links).
  const navigateBack = (fallbackUrl) => {
    if (window.history.length > 2) {
      history.goBack()
    } else {
      history.push(fallbackUrl)
    }
  }

  const redirectTo = (url) => {
    window.location = url
  }

  const toIndex = () => {
    redirectTo(process.env.REACT_APP_BACKEND_URI)
  }

  const navigateTo = (page, args) => {
    if (args.group_id !== undefined) {
      navigate(routes[page](args))
    }
  }

  const routes = {
    sorry: () => "/sorry",
    accountingBookPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books`,
    groupMembersPage: (args) => `/liff_entry/groups/${args.group_id}/members`,
    accountingBookCreationPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/new`,
    deletedAccountingBooksPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/deleted`,
    accountingBookCurrencyPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/currency`,
    accountingBookSettingsPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/settings`,
    accountingBookEditPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/edit/index`,
    accountingBookDefaultUserPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/default_users`,
    accountingBookSummaryPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/payments/summary`,
    paymentIndexPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/payments/index`,
    overviewPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/overview`,
    paidBackPaymentPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/payments/paid_back?`,
    paymentsFilterPage: (args) => `/liff_entry/groups/${args.group_id}/accounting_books/${args.accounting_book_id}/payments/filter`
  }

  return { navigate, navigateBack, navigateTo, routes, toIndex, redirectTo };
}

export default Hook;
